import React, { useState } from "react";
import { PlayIcon, cn } from "@lemonadetraining/web-ui";

interface YouTubeEmbedProps {
  id: string;
  title: string;
  className?: string;
}

/* Click to load: YouTube's player stores data in the browser as soon as it
 * loads, even in privacy mode, and the privacy policy promises nothing from
 * YouTube until the viewer presses play. So no iframe or thumbnail before that. */
const YouTubeEmbed: React.FC<YouTubeEmbedProps> = ({ id, title, className }) => {
  const [playing, setPlaying] = useState(false);

  return (
    <div className={cn("aspect-video w-full overflow-hidden rounded-lg bg-muted", className)}>
      {playing ? (
        <iframe
          className="size-full"
          src={`https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}?autoplay=1`}
          title={title}
          // The pressed button unmounts; without this, keyboard focus falls to <body>.
          onLoad={(event) => event.currentTarget.focus()}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        />
      ) : (
        <button
          type="button"
          aria-label={`Play ${title}`}
          onClick={() => setPlaying(true)}
          className="group flex size-full flex-col items-center justify-center gap-2 text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ring"
        >
          <span className="grid size-14 place-items-center rounded-full bg-background text-foreground shadow-sm transition-transform group-hover:scale-105">
            <PlayIcon className="size-6" aria-hidden="true" />
          </span>
          <span className="text-sm">Play video (loads from YouTube)</span>
        </button>
      )}
    </div>
  );
};

export default YouTubeEmbed;
